import escapeRegExp from "lodash/escapeRegExp";
import isEmpty from "lodash/isEmpty";
import pick from "lodash/pick";
import type { ServiceSearchType } from "../../types/search/service-search.type";
import type { IProduct } from "./ApiClientBonusXServiceRepository/interfaces/IProduct.interface";

export interface ISearchableService {
  type?: string;
}

type AcceptedFieldsToSearch = (keyof IProduct)[];
export const FIELDS_TO_SEARCH: AcceptedFieldsToSearch = ["name", "shortDescription"];

export function splitPhraseIntoWords(phrase: string): string[] {
  return phrase.split(" ");
}

export function buildMatcher(phrase: string): (textToMatch: string) => boolean {
  const matcher = new RegExp(escapeRegExp(phrase), "gim");
  return function match(textToMatch: string) {
    return !!textToMatch.match(matcher);
  };
}

function matchTypes(selectedTypefilter: string, serviceType: string = ""): boolean {
  const isSameType = serviceType === selectedTypefilter;
  return isEmpty(selectedTypefilter) ? true : isSameType;
}

function serializeService(service: ISearchableService, acceptedFields: string[]): string {
  const fieldsToCheck = pick(service, acceptedFields);
  return JSON.stringify(fieldsToCheck).toLowerCase();
}

function buildSearchTextInService<TService extends ISearchableService>(
  searchOptions: ServiceSearchType,
  matchSearch: (text: string) => boolean
) {
  return function searchTextInService(service: TService) {
    const serializeFields = serializeService(service, FIELDS_TO_SEARCH);

    const hasTypeAndIsSame = matchTypes(searchOptions.filter, service?.type);
    const hasMatchWithData = matchSearch(serializeFields);

    return hasMatchWithData && hasTypeAndIsSame;
  };
}

export function serviceCollectionFilter<TService extends ISearchableService>(
  services: TService[],
  searchOptions: ServiceSearchType
): TService[] {
  if (!(searchOptions.textInput || searchOptions.filter)) {
    return services;
  }

  const searchText = searchOptions.textInput;
  const matcher = buildMatcher(searchText);

  const searchTextInService = buildSearchTextInService(searchOptions, matcher);
  const results = services.filter(searchTextInService);

  return results;
}
